import {NavigationGuard, Route} from "vue-router";
import * as userService from "@/service/userService";

const redirectIfLoggedInGuard: NavigationGuard = async (to: Route, from: Route, next) => {
  const user = userService.isSignedIn();
  if (user) {
    next({ path: '/' });
  } else {
    next();
  }
};

export default redirectIfLoggedInGuard;
